import { useCallback } from 'react';

import { getFragmentData } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { ServiceUsageCardCmp_ResolvableServiceUsage_Fragment } from '../Card/fragments/resolvable-service-usage.fragment';
import { ServiceUsageCardCmp_ServiceUsage_Fragment } from '../Card/fragments/service-usage.fragment';
import type { ServiceUsagesType } from '../types/props.type';

export const useGetServiceUsagesData = () =>
  useCallback(
    <R extends boolean>(
      isResolvable: R,
      serviceUsages: ServiceUsagesType<R> | undefined | null,
    ) =>
      !serviceUsages
        ? serviceUsages
        : isResolvable
          ? getFragmentData(
              ServiceUsageCardCmp_ResolvableServiceUsage_Fragment,
              serviceUsages as readonly FragmentType<
                typeof ServiceUsageCardCmp_ResolvableServiceUsage_Fragment
              >[],
            )
          : getFragmentData(
              ServiceUsageCardCmp_ServiceUsage_Fragment,
              serviceUsages as readonly FragmentType<
                typeof ServiceUsageCardCmp_ServiceUsage_Fragment
              >[],
            ),
    [],
  );
